require('~/lib/polyfills/object-entries')
require('~/lib/polyfills/array-from')